var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPencil = function SvgPencil(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.85 4.8C17.4913 4.8 17.1476 4.94223 16.8946 5.19481L16.1829 5.90505L18.0912 7.80953L18.8054 7.09672C19.0585 6.8442 19.2003 6.5021 19.2003 6.14576C19.2003 5.78943 19.0585 5.44733 18.8054 5.19481C18.5524 4.94223 18.2087 4.8 17.85 4.8ZM16.8171 9.08104L14.9088 7.17656L4.8 17.265V19.2H6.67774L16.8171 9.08104ZM14.2718 5.2693C14.2724 5.26868 14.273 5.26807 14.2736 5.26746L15.623 3.92073C16.214 3.33099 17.0151 3 17.85 3C18.6849 3 19.486 3.33099 20.077 3.92073C20.6679 4.51054 21.0003 5.31087 21.0003 6.14576C21.0003 6.98066 20.6679 7.78099 20.077 8.3708L7.68575 20.737C7.51702 20.9054 7.28838 21 7.05 21H3.9C3.40294 21 3 20.5971 3 20.1V16.8917C3 16.6527 3.09507 16.4235 3.26425 16.2546L14.2718 5.2693Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Pencil.c738eb128ac88a25d84f800e3385037f.svg";